import * as _ from "lodash-es";
import * as storage from "../utils/tool/data";

export const LQA_NAME: string = "lqa_game";
export const LQC_NAME: string = "ecis_comic";

export const SYSTEM_NAME = {
  [LQA_NAME]: "LQA",
  [LQC_NAME]: "LQC"
}

export const SYSTEM_API_BASIS = {
  [LQA_NAME]: "lqa-game",
  [LQC_NAME]: "eci-comic"
}

export const getSystemList = function () {
  const list = storage.get("SYSTEM_APP") || [];
  const res: Array<{ key: string; value: string }> = [];
  for (const value of list) {
    switch (_.toLower(value)) {
      case _.toLower(LQA_NAME):
        res.push({key: LQA_NAME, value: SYSTEM_NAME[LQA_NAME]});
        break;
      case _.toLower(LQC_NAME):
        res.push({key: LQC_NAME, value: SYSTEM_NAME[LQC_NAME]});
        break;
    }
  }
  return res;
}

export const isOnlyLQA = function (): boolean {
  const apps = getSystemList();
  if (apps.length === 1) {
    if (apps[0].key === LQA_NAME) {
      return true;
    }
  }
  return false;
}

export const isOnlyLQC = function (): boolean {
  const apps = getSystemList();
  if (apps.length === 1) {
    if (apps[0].key === LQC_NAME) {
      return true;
    }
  }
  return false;
}
